import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import ErrorBoundary from '../../../../../ErrorBoundary';

const MetadataMappingInsertFieldModal = ({
  handleClose, options, flatOptions, handleInsertField,
}) => {
  const intl = useIntl();

  const [selectValue, setSelectValue] = useState(null);

  return (
    <ErrorBoundary>
      <ModalHeader toggle={handleClose}>
        {intl.formatMessage({ defaultMessage: 'Insert Field' })}
      </ModalHeader>
      <ModalBody style={{ overflow: 'visible' }}>
        <Select
          options={options}
          onChange={option => setSelectValue(option.value)}
          defaultValue={selectValue || flatOptions[0]}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          className="metadata-mapping-select"
        />
        <p>
          {intl.formatMessage({
            defaultMessage: 'Field will be inserted as <strong>{value}</strong>',
          }, { value: selectValue || flatOptions[0].value })}
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="buttons-group">
          <Button
            color="secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ defaultMessage: 'Cancel' })}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              handleInsertField(`{{${selectValue}}}`);
              handleClose();
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Insert' })}
          </Button>
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

MetadataMappingInsertFieldModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleInsertField: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  flatOptions: PropTypes.array.isRequired,
};

export default MetadataMappingInsertFieldModal;
